<script setup lang="ts">
import { REGULAR_EXPEDITIONS } from '~/shared/expedition'

const cod_fees = ref<{ key?: string | null; value?: string | null }[]>()
const couriers = ref<
  {
    code?: string | null
    service_name?: string | null
    service_type_name?: string | null
    image?: string | null
  }[]
>()

onMounted(() => {
  $fetch('/intl-api/courier').then((res) => {
    couriers.value = res.couriers
    cod_fees.value = res.cod_fees
  })
})

const dataWithImage = computed(() =>
  couriers.value?.map((courier) => {
    const findCourier = REGULAR_EXPEDITIONS.find(
      (expedition) => expedition.code === courier.code
    )
    return {
      ...courier,
      icon: findCourier?.icon,
      icon_class: findCourier?.class
    }
  })
)

const findCodFee = (code?: string) => {
  if (!code) return null

  const defaultFee = cod_fees.value?.find((fee) => fee.key === 'cod_fee')
  const specificFee = cod_fees.value?.find(
    (fee) => fee.key === `cod_fee_${code}`
  )

  const fee = specificFee?.value || defaultFee?.value || null
  if (!fee) return null

  return parseFloat(fee) * 100 + '% + PPN'
}
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionTitle
      class="text-center"
      title="Layanan Reguler Ekspedisi<br/>yang Siap Penuhi Kebutuhan Pengirimanmu"
      title-as="h2"
      description="Temukan berbagai layanan pengiriman reguler di KiriminAja.
Informasi layanan dapat menyesuaikan sewaktu-waktu sesuai kebijakan ekspedisi."
    />
    <div class="w-full max-w-3xl mx-auto flex flex-col gap-2">
      <div
        v-for="(expedition, index) in dataWithImage"
        :key="index"
        class="border border-outline-variant p-4 rounded-xl bg-surface-container-low flex flex-col md:flex-row md:items-center gap-2"
      >
        <div class="md:flex-1 md:max-w-56 flex items-center gap-2">
          <UiCourierService
            v-if="expedition.icon"
            :icon="expedition.icon"
            :icon-class="expedition.icon_class"
          />
          <img
            v-else
            :src="expedition.image || ''"
            :alt="expedition.service_name || ''"
            class="h-12 aspect-video border bg-white border-outline-variant rounded-lg object-contain"
          />

          <div class="flex flex-col grow">
            <span class="text-xs text-on-surface-variant">Ekspedisi</span>
            <span class="font-semibold text-sm">{{
              expedition.service_name
            }}</span>
          </div>
        </div>
        <div
          class="md:flex-1 flex flex-col md:flex-row md:justify-between gap-2 grow md:items-center"
        >
          <div class="flex flex-col">
            <span class="text-xs text-on-surface-variant">Layanan</span>
            <span class="font-semibold text-sm">{{
              expedition.service_type_name?.replaceAll(';', ', ')
            }}</span>
          </div>
          <div class="flex-none flex flex-col pr-5">
            <span class="text-xs text-on-surface-variant">COD Fee</span>
            <span class="font-semibold text-sm">
              {{ findCodFee(expedition.code ?? undefined) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </UiContainer>
</template>
